import { clone } from '@range.io/functional'
import DataStore from '@range.io/mock/src/firebase/datastore.js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { sampleData } from '../../firebase-tools-and-tests/raw-sample-data.js'
import { App } from './components-application/index.js'
import CommandHistory from './firebase/commands/command-history.js'
import { EntireProjectLoadedCommand, InitialDataLoadedCommand } from './firebase/commands/index.js'
import { UndoRedo } from './firebase/commands/UndoRedo.js'
import './index.css'
import { ReduxActions } from './redux/index.js'
import createStore from './redux/store.js'

const store = createStore()

// add a function that resets all the sample data after a useCase runs
if (typeof window !== 'undefined' && window.Cypress) {
    window.cypressUseCaseTeardown = async (userId = '3e4637e1-02f4-4fe3-b714-c281fb1ea691' /* jeff */) => {
        const rangeId = 'c39f1e8b-cabb-44c9-822e-e0d7ee92a90d'
        const vanderbiltProject = '474503d1-1adc-4268-88fe-2a797148f16d'

        const commandHistory = CommandHistory(store)
        const { resourceRemoved, resourceChanged, runCommand } = commandHistory

        // reset the mock-firebase data
        window.mockFirebase.dataStore = DataStore(clone(sampleData()))

        // remove the current Firestore listeners and add them back
        resourceRemoved('userId')
        resourceRemoved('organizationId')
        resourceRemoved('projectId')
        resourceChanged('userId', userId)
        resourceChanged('organizationId', rangeId)
        resourceChanged('projectId', vanderbiltProject)

        // reset redux and load the user and project data
        store.dispatch(ReduxActions.reset())
        store.dispatch(ReduxActions.userLogIn()) // mark the user as logged in
        await runCommand(InitialDataLoadedCommand.Outbound(userId))
        await runCommand(EntireProjectLoadedCommand.Outbound({ id: vanderbiltProject }))
    }
}

const root = createRoot(document.getElementById('root'))
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <UndoRedo>
                <App />
            </UndoRedo>
        </React.StrictMode>
    </Provider>
)
